var _style, _path, _rect, _rect2, _line, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFreezer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 28.35 28.35",
    style: {
      enableBackground: "new 0 0 28.35 28.35"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t\r\n\t\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:none;stroke:#000000;stroke-width:1.5001;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:22.9256;}\r\n\t\r\n\t\t.st1{fill-rule:evenodd;clip-rule:evenodd;fill:none;stroke:#000000;stroke-width:1.0001;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:22.9256;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M8.74,2.17H19.6c0.79,0,1.43,0.65,1.43,1.43v19.92c0,0.79-0.65,1.43-1.43,1.43H8.74 c-0.79,0-1.43-0.65-1.43-1.43V3.6C7.31,2.81,7.96,2.17,8.74,2.17z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 8.74,
    y: 24.95,
    className: "st0",
    width: 1.16,
    height: 1.49
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 18.44,
    y: 24.95,
    className: "st0",
    width: 1.16,
    height: 1.49
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 8.74,
    y1: 14.26,
    x2: 8.74,
    y2: 19.16
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M15.41,5.42l-1.24,1.2 M9.63,8.73l1.2,1.24 M9.16,9.96h10.02 M18.72,8.73l-1.2,1.24 M18.72,11.2l-1.2-1.24  M9.63,11.2l1.2-1.24 M16.51,5.88l0.03,1.72 M17.71,6.42l-7.08,7.08 M10.09,12.3l1.72,0.02 M11.83,14.05l-0.03-1.72 M18.26,7.63 L16.54,7.6 M11.83,5.88L11.81,7.6 M10.63,6.42l7.08,7.08 M18.26,12.3l-1.72,0.02 M16.51,14.05l0.03-1.72 M10.09,7.63l1.72-0.03  M14.17,4.96v10.02 M15.41,14.51l-1.24-1.2 M12.94,14.51l1.24-1.2 M12.94,5.42l1.24,1.2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFreezer);
export default __webpack_public_path__ + "static/media/freezer.398608fd52a2a2bfbbec6610f856722d.svg";
export { ForwardRef as ReactComponent };